module.exports = ".wrapper{\r\n    border:1px solid #e7e7e7;\r\n}\r\n\r\n.wrapper .row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/experiencedetails/experiencedetails-form/experiencedetails-form.component.css
// module id = ./src/app/hrms/serviceregister/experiencedetails/experiencedetails-form/experiencedetails-form.component.css
// module chunks = main